import * as ttCookie from '@tt/cookie';

import config from './config';

const extraHints = () => [
    config.get('TRADING_TERMINAL_BASE_URL') || '',
    config.get('TT_URL') || '',
    process.env.NODE_ENV || ''
];

export const getClientEnv = () => ttCookie.getClientEnv(extraHints());
export const getCookie = (name) => ttCookie.getCookie(name, extraHints());
export const setCookie = (name, value, expire) =>
    ttCookie.setCookie(name, value, expire, extraHints());
export const removeCookie = (name) => ttCookie.removeCookie(name, extraHints());
export const parseUserToken = () => ttCookie.parseUserToken(extraHints());
